module.exports = __webpack_public_path__ + "50221bac8cc75700ccc40f43ff0584da.png";